/* eslint-disable @typescript-eslint/no-misused-promises */
import { useCallback } from 'react';
import { Container, Difficulty, DifficultyType, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { faChevronDoubleRight as faChevronDoubleRightDuotone } from '@fortawesome/pro-duotone-svg-icons';
import { faDoorClosed, faLayerGroup } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as CloudBanner } from 'src/images/svgs/path-outline/cloud-banner.svg';
import { hasResponseData } from 'src/common/helpers/slices';
import { SOMETHING_WENT_WRONG } from 'src/common/constants';
import { ApiResponseStatus } from 'src/common/enums';
import { AlternativePath } from 'src/common/components/alternative-path/alternative-path';
import { useEnrollInPathMutation } from '../../path-outline.slice';
import { PathOutlineBannerProps } from './path-outline-banner.types';
import { StyledBannerContent, StyledBannerCard, StyledStatisticsBoxIconNumberContainer, StyledBannerCardNumber, StyledBannerCardLabel, StyledBannerCardIcon, StyledBannerCardRow, StyledBanner, StyledTypeText, StyledTitle, StyledSummary, StyledDifficulty, StyledButton } from './path-outline-banner.styles';
export const PathOutlineBanner: React.FC<PathOutlineBannerProps> = ({
  pathCode,
  title,
  summary,
  taskNo,
  rooms,
  difficulty,
  isRetired,
  alternativePath
}) => {
  const navigate = useNavigate();
  const [enrollInPathMutation] = useEnrollInPathMutation();
  const enrollInPath = useCallback(async () => {
    const enroll = await enrollInPathMutation(pathCode ?? '');
    if (hasResponseData<string>(enroll) && enroll.data.status === ApiResponseStatus.SUCCESS) {
      navigate('/paths');
    } else {
      NotificationDispatch('error', SOMETHING_WENT_WRONG);
    }
  }, [enrollInPathMutation, navigate, pathCode]);
  return <StyledBanner className="lightBanner" Image={CloudBanner} top="-35rem" left="-30rem" data-sentry-element="StyledBanner" data-sentry-component="PathOutlineBanner" data-sentry-source-file="path-outline-banner.tsx">
      <StyledBannerContent data-sentry-element="StyledBannerContent" data-sentry-source-file="path-outline-banner.tsx">
        <Container data-sentry-element="Container" data-sentry-source-file="path-outline-banner.tsx">
          <StyledTypeText data-sentry-element="StyledTypeText" data-sentry-source-file="path-outline-banner.tsx">Learning path</StyledTypeText>
          <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="path-outline-banner.tsx">{title}</StyledTitle>
          <StyledSummary data-sentry-element="StyledSummary" data-sentry-source-file="path-outline-banner.tsx">{summary}</StyledSummary>
          <StyledBannerCardRow data-sentry-element="StyledBannerCardRow" data-sentry-source-file="path-outline-banner.tsx">
            <StyledBannerCard data-sentry-element="StyledBannerCard" data-sentry-source-file="path-outline-banner.tsx">
              <StyledBannerCardLabel data-sentry-element="StyledBannerCardLabel" data-sentry-source-file="path-outline-banner.tsx">Modules</StyledBannerCardLabel>
              <StyledStatisticsBoxIconNumberContainer data-sentry-element="StyledStatisticsBoxIconNumberContainer" data-sentry-source-file="path-outline-banner.tsx">
                <StyledBannerCardIcon icon={faLayerGroup} data-sentry-element="StyledBannerCardIcon" data-sentry-source-file="path-outline-banner.tsx" />
                <StyledBannerCardNumber data-sentry-element="StyledBannerCardNumber" data-sentry-source-file="path-outline-banner.tsx">{taskNo}</StyledBannerCardNumber>
              </StyledStatisticsBoxIconNumberContainer>
            </StyledBannerCard>
            <StyledBannerCard data-sentry-element="StyledBannerCard" data-sentry-source-file="path-outline-banner.tsx">
              <StyledBannerCardLabel data-sentry-element="StyledBannerCardLabel" data-sentry-source-file="path-outline-banner.tsx">Hands-on labs</StyledBannerCardLabel>
              <StyledStatisticsBoxIconNumberContainer data-sentry-element="StyledStatisticsBoxIconNumberContainer" data-sentry-source-file="path-outline-banner.tsx">
                <StyledBannerCardIcon icon={faDoorClosed} data-sentry-element="StyledBannerCardIcon" data-sentry-source-file="path-outline-banner.tsx" />
                <StyledBannerCardNumber data-sentry-element="StyledBannerCardNumber" data-sentry-source-file="path-outline-banner.tsx">{rooms}</StyledBannerCardNumber>
              </StyledStatisticsBoxIconNumberContainer>
            </StyledBannerCard>
            <StyledBannerCard data-sentry-element="StyledBannerCard" data-sentry-source-file="path-outline-banner.tsx">
              <StyledBannerCardLabel data-sentry-element="StyledBannerCardLabel" data-sentry-source-file="path-outline-banner.tsx">Difficulty level</StyledBannerCardLabel>
              <StyledDifficulty data-sentry-element="StyledDifficulty" data-sentry-source-file="path-outline-banner.tsx">
                <Difficulty difficulty={(difficulty.toLowerCase() as DifficultyType)} hasIcon isDarkVersion data-sentry-element="Difficulty" data-sentry-source-file="path-outline-banner.tsx" />
              </StyledDifficulty>
            </StyledBannerCard>
          </StyledBannerCardRow>

          {isRetired && alternativePath ? <AlternativePath alternativePath={alternativePath} /> : <StyledButton color="add" onClick={enrollInPath}>
              Enroll in path <FontAwesomeIcon icon={faChevronDoubleRightDuotone} />
            </StyledButton>}
        </Container>
      </StyledBannerContent>
    </StyledBanner>;
};